<template>
  <div :class="wrapperClass" v-if="showProduct">
      <div class="product-card" :class="{'product-card-oos': product.OnHand < 1}">
          <div class="product-image">
              <a :href="url" v-lazy-container="{ selector: 'img', error: defaultImage }">
                  <img data-loading="/images/default/ajax-loader.gif"
                       :data-src="image"
                       class="img-responsive" />
              </a>
          </div>
          <div class="product-description">
              <p class="description">
                  <a :href="url"
                     :title="title"
                     class="text-capitalize"
                     data-toggle="tooltip"
                     data-placement="top">
                      {{ title }}

                      <span class="product-price" v-if="showPrice">
                          {{ this.product.Price }}
                      </span>
                  </a>
              </p>
              <p v-if="hasManufacturer || hasCustomFormat">
                  <span v-if="hasManufacturer">
                      {{ product.Manufacturer }}
                  </span>
                  <span v-if="hasManufacturer">
                      -
                  </span>
                  <span v-if="hasCustomFormat">
                      {{product.CustomFormat}}
                  </span>
              </p>

              <p v-if="settings.ShowCategoryOnProduct && hasCategory">
                  {{ product.Category.Description }}
              </p>

              <p class="format">
                  {{ format  }}
              </p>

              <p class="product-on-hand"
                 :class="{'out-of-stock-wrapper': product.OnHand < 1}"
                 v-if="(settings.ShowQty || settings.IsAdmin || settings.ShowOOS) && (!product.IsSoftware)">

                  <span v-if="product.OnHand > 0 && (settings.ShowQty || settings.IsAdmin)" class="stock">
                      {{getLabel('qtyinstock')}} 
                      <span class="product-stock-qty">
                          {{ product.OnHand | roundNumber }}
                      </span>                        
                  </span>
                  <span class="text-danger out-of-stock" v-if="product.OnHand < 1">

                      {{getLabel('web_outofstock')}}
                      <span>
                          <br />
                          {{ dateToReceive }}
                      </span>

                  </span>

                  <span class="out-of-stock-message" v-if="product.OnHand < 1">
                  </span>
              </p>

              <p class="text-success product-on-hand" v-if="product.IsSoftware">
                  {{ getLabel('store-software') }}
              </p>

              <p class="tag-holder" v-if="hasTags">
                  <span class="tag-text" 
                    v-for="tag in tags"
                    :key="tag.Id">
                      {{ tagDescription(tag) }}
                  </span>
              </p>
          </div>

          <div class="product-action">
              <div class="product-quantity" v-if="!product.IsSoftware && !product.IsCustom">
                  <label class="floating-label floating-label-shown"
                         :for="product.Id">
                      {{getLabel('qte')}}
                  </label>
                  <input :id="product.Id"
                         v-model="quantity"
                         type="number" min="0" class="qty input-lg form-control">
              </div>
              <a v-if="!product.IsSoftware && !product.IsCustom"
                 :href="url"
                 @click="addToCart($event)"
                 class="btn btn-lg btn-primary btn-add-to-cart">
                  {{getLabel('_webaddtocart')}}
                  <span v-show="!isAdding"
                        class="glyphicon glyphicon-shopping-cart">
                  </span>
                  <img v-show="isAdding"
                       alt="loading"
                       src="/images/default/spinner-inverse-sm.gif">
              </a>

              <a v-if="product.IsSoftware || product.IsCustom"
                 :href="url" 
                 class="btn btn-lg btn-primary btn-add-to-cart">
                  {{getLabel('view')}}
                  <span class="glyphicon glyphicon-eye-open">
                  </span>
              </a>
          </div>
      </div>
  </div>
  
</template>
<script>    
  export default {
      created: function () {
          this.quantity = this.settings.DefaultQty == 0 ? '' : this.settings.DefaultQty;
      },
      props: ['settings', 'product', 'labels', 'wrapperClass'],
      data: function () {
          return {                
              quantity: '',
              isAdding: false
          }
      },
      methods: {
          tagDescription: function (tag) {
              var description = tag.Description;
              return description;
          },
          getLabel: function (key) {
              var self = this;

              var index = _.findIndex(self.labels, function (o) {
                  return o.Key == key;
              });

              if (index == -1) {
                  return "";
              }

              return self.labels[index].Value;
          },
          addToCart: function (event) {
              var self = this;
              event.preventDefault();
              self.isAdding = true;

              var cart = {
                  StoreId: 0,
                  CartId: Cookies.get('marketplace-cart'),
                  LangId: Cookies.get('marketplace-lang'),
                  ItemId: self.product.Id,
                  Qty: self.quantity
              };

              $.ajax({
                  type: 'POST',
                  url: '/api/apicart/add/',
                  contentType: 'application/json; charset=UTF-8',  //send type of data to sever
                  dataType: 'text', //retrun type of data from server
                  traditional: true,
                  data: JSON.stringify(cart)
              })
                  .done(function (data, textStatus, xhr) {
                      switch (xhr.status) {
                          case 202:
                              //Add success msg
                              toastr["warning"](data.replace(/"/g, ""));
                              break;
                          default:
                              //Add success msg                        
                              toastr["success"](data.replace(/"/g, ""));
                      }
                  })
                  .fail(function (XMLHttpRequest, textStatus) {
                      var errorMsg = XMLHttpRequest.responseText === undefined ? textStatus : XMLHttpRequest.responseText.replace(/"/g, "");
                      toastr["error"](errorMsg);
                  })
                  .always(function () {
                      //Update shopping cart qty 
                      self.isAdding = false;
                      UpdateCart();
                  })
          }
      },
      filters: {            
          roundNumber: function (value) {
              return _.round(value, 0);
          }
      },
      computed: {
          title: function () {
              var title = "";

              if (this.product.Collection != '') {
                  title = this.product.Collection + " - "; 
              }

              title += this.product.Description;
              
              return title;
          },
          showProduct: function () {
              var result = true;
              if (this.settings.HideOutOfStock == true && this.product.OnHand < 1 && this.product.IsAlwaysVisible == false) {
                  result = false;
              }

              return result;
          },
          showPrice: function () {
              var result = false;
              if (this.settings.ShowPrice == true || this.settings.IsAdmin == true) {
                  result = true;
              }

              return result;
          },
          url: function () {                
              return '/' + this.settings.CustomerId + '/product/index/' + this.product.Id;
          },
          hasCollection: function () {
              var hasCollection = false;

              if (this.product.Collection != '') {
                  hasCollection = true;
              }

              return hasCollection;
          },
          hasManufacturer: function () {
              var hasManufacturer = false;
              if (this.product.Manufacturer != '') {
                  hasManufacturer = true;
              }

              return hasManufacturer;
          },
          hasCategory: function () {
              if (this.product.Category) {
                  return true;
              }
              return false;
          },
          hasCustomFormat: function () {
              var hasCustomFormat = false;
              if (this.product.CustomFormat != '') {
                  hasCustomFormat = true;
              }

              return hasCustomFormat;
          },
          category: function () {
              var category = "";
              if (this.product.Category) {
                  category = this.product.Category.Description;
              }

              return category;
          },
          format: function () {
              var format = "";
              if (this.product.Format !== "") {
                  format = this.product.Format;
              }

              return format;
          },
          hasTags: function () {
              var index = _.findIndex(this.product.Tags, function (o) {
                  return o.Hidden == true;
              });

              return index == -1 ? false : true;
          },
          tags: function () {
              var tags = _.filter(this.product.Tags, function (o) {
                  return o.Hidden == true;
              });

              return tags;
          },
          image: function () {

              if (this.product.Image) {
                  return this.product.Image.replace('~', '');
              }
              else {
                  return this.settings.MissingImage;
              }
          },
          defaultImage: function () {
              return this.settings.MissingImage;
          },
          dateToReceive: function () {
              var self = this;
              var formattedDate = moment(self.product.DateToReceive).format('MM/DD/YYYY');
              if (formattedDate == 'Invalid date') {
                  return '';
              }
              else {
                  return formattedDate;
              }
          }
      }
  }
</script>